import { render, staticRenderFns } from "./MenuStatisticsV3.vue?vue&type=template&id=7d7141fa&scoped=true"
import script from "./MenuStatisticsV3.vue?vue&type=script&lang=js"
export * from "./MenuStatisticsV3.vue?vue&type=script&lang=js"
import style0 from "./MenuStatisticsV3.vue?vue&type=style&index=0&id=7d7141fa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7141fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d7141fa')) {
      api.createRecord('7d7141fa', component.options)
    } else {
      api.reload('7d7141fa', component.options)
    }
    module.hot.accept("./MenuStatisticsV3.vue?vue&type=template&id=7d7141fa&scoped=true", function () {
      api.rerender('7d7141fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/v3/MenuStatisticsV3.vue"
export default component.exports